// extracted by mini-css-extract-plugin
export var title = "styles-module--title--59731";
export var wrapper = "styles-module--wrapper--bb805";